// @flow
import { connect } from 'react-redux'
import ProviderUtmPage from './ProviderUtmPage'
import _ from 'lodash'
import * as reducer from '../redux/ducks/providerUtmPage/reducers'
import type { State } from '../redux/ducks/providerUtmPage/reducers'
import type { Store } from '../redux/ducks'
import getJson from '../services/getJson'
import postJson from '../services/postJson'
import store from '../redux/store'

const UTMS_URL = '/api/v1/provider_utms'
const SET_UTMS_URL = '/api/v1/provider_utms/set_utms'

const t = {
  success: 'UTM-метки успешно установлены'
}

function mapStateToProps(state: Store, ownProps) {
  return {
    ...ownProps,
    ...state.providerUtmPage
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onInit: () => {
      getJson(UTMS_URL).done((response) => {
        const utmData = {
          utmType: response.data.utm_type,
          providerUtms: {
            vk: response.data.vk,
            target_mail: response.data.target_mail,
            facebook: response.data.facebook,
            instagram: response.data.instagram,
            google: response.data.google
          },
          ortUtm: response.data.ort,
          updateType: response.data.update_type,
          isLoading: false
        }
        dispatch(reducer.init(utmData))
      })
    },
    onChange: (diff: $Shape<State>) => {
      dispatch(reducer.patch(diff))
    },
    onApply: () => {
      const state = store.getState()
      const { utmType, providerUtms, ortUtm, updateType } = state.providerUtmPage
      const data = {
        utm_type: utmType,
        ort: ortUtm,
        vk: providerUtms.vk,
        target_mail: providerUtms.target_mail,
        facebook: providerUtms.facebook,
        instagram: providerUtms.instagram,
        google: providerUtms.google,
        update_type: updateType
      }
      dispatch(reducer.patch({ isLoading: true }))
      postJson(SET_UTMS_URL, { data: data })
        .done(() => window.alert(t.success))
        .fail(() => window.alert('Internal error'))
        .always(() => dispatch(reducer.patch({ isLoading: false })))
    }
  }
}

const ProviderUtmPageContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(ProviderUtmPage)

export default ProviderUtmPageContainer
